import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import { TransferStatusPlate } from "../../..";
import { TransferStatus } from "../../../../types";

export const statusGridCellFactory = <T, K extends string>(
  getStatus: (data: T) => K
) => (props: ICellRendererParams) => {
  const data = props.data as T;
  const status = getStatus(data);

  return (
    <TransferStatusPlate
      statusCode={(status as unknown) as TransferStatus}
      isAdjustable={(data as any)?.isAdjustable}
    />
  );
};

export default statusGridCellFactory;
